import * as api from "@/api";
import {formatPhone} from "@/utils/helpers";

const initState = () => ({
  process: "init",
  phone: "",
  smsid: "",
  code: "",
  err: "",
  pass: "",
  resend_delay: "",
  show_confirm: false,
  show_phone: true,
});

export default {
  namespaced: true,
  state: initState,
  getters: {
    phone: (state) => state.phone.replace(/\D/g, ""),
    phoneFormatted: (state) => formatPhone(state.phone),
    err: (state) => state.err,
    resend_delay: (state) => state.resend_delay,
    // отображение формы перевода логина
    show_phone: (state, getters, rootState, rootGetters) => state.show_phone && !rootGetters['profile/isTransfered'],
  },
  mutations: {
    setApply: (state) => (state.process = "apply"),
    setInit: (state) => (state.process = 'init'),
    setPhone: (state, value) => (state.phone = value),
    setPass: (state, value) => (state.pass = value),
    setSms: (state, value) => (state.smsid = value),
    setCode: (state, value) => (state.code = value),
    setError: (state, value) => (state.err = value),
    setConfirm: (state, value) => (state.show_confirm = value),
    setResendDelay: (state, value) => (state.resend_delay = value),
    setPhoneForm: (state, value) => (state.show_phone = value),

    reset: state => {
      const initialState = initState();
      Object.keys(initialState).forEach(key => (state[key] = initialState[key]));
    }
  },
  actions: {
    // Смена логина в два этапа:
    // 1) отправка номера (process: 'init')
    // 2) отправка номера, сммскода и смсайди (process: 'apply')
    async transferUser({state: {process, smsid, code, pass}, getters: {phone}, commit}) {
      const res = await api.transferUser({process, smsid, code, phone, pass});
      if (res) {
        if (process === 'init') {
          // закрываем модалку с телефоном
          commit("setPhoneForm", false);
          // устанавливаем данные для подтверждения
          commit("setApply");
          commit("setSms", res.smsid);
          // открываем модалку подтверждения
          commit("setConfirm", true);
          if (res.resend_delay) {
            commit("setResendDelay", res.resend_delay);
          } else {
            commit("setResendDelay", 180);
          }
        } else {
          // сбрасываем стейт
          commit("reset");
          // закрываем модалку c телефоном
          commit("setPhoneForm", false);
        }
      } else {
        commit("setError", res.errdesc);
      }
    }
  }
};
